<template>
  <div class="account">
    <div class="table">
      <span class="navigation">
        <span class="navContent">
          <b-icon
            id="previousMonth"
            v-on:click="previousMonth"
            icon="triangle-fill"
            title="Mois précédent"
          />
          <span id="displayMonth">
            {{ months[curMonth - 1] }} {{ year }}
          </span>
          <b-icon
            id="nextMonth"
            v-on:click="nextMonth"
            icon="triangle-fill"
            title="Mois suivant"
          />
        </span>
      </span>

      <table class="table table-sm mx-auto col-sm-12">
        <thead>
          <th scope="col" class="today"></th>
          <th scope="col" class="week" colspan="3"></th>
          <th scope="col"></th>
        </thead>
        <tbody>
          <tr
            v-for="day in nbDays"
            :key="day"
            :id="day"
            v-bind:style="{
              background: holidays[day] ? allColors.HOLIDAYS : allColors.NONE
            }"
          >
            <th class="row today">
              <span
                id="rightDay"
                v-if="
                  day === today &&
                    curMonth === todaysMonth &&
                    year === todaysYear
                "
              ></span>
            </th>
            <td
              class="week"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              <span v-if="(day + shiftDay) % 7 == 1">
                {{ weeks[parseInt(day / 7)] }}
              </span>
            </td>
            <td
              class="date"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              {{ days[(day + shiftDay) % 7] }}
            </td>
            <td
              class="number"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              {{ day }}
            </td>
            <td v-if="holidays[day]"></td>
            <td v-else class="events">
              <span v-for="ev in events[day]" :key="ev.id">
                <EventLeave
                  :leave="ev"
                  :nbLeave="events[day].length"
                  :idToColor="projectIdToColor"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

import { colors } from "../../settings.js";
import EventLeave from "./EventLeave.vue";

export default {
  name: "DashboardLeave",
  components: {
    EventLeave
  },
  data() {
    return {
      nbDays: 0,
      events: [],
      daySelected: 0,
      overlay: false,
      detailsOverlay: false,
      copyOverlay: false,
      statsOverlay: false,
      today: "",
      days: ["D", "L", "M", "M", "J", "V", "S"],
      shiftDay: 0, //calcul the first day of the month
      weeks: [],
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
      ],
      curMonth: 0, // January is  1
      todaysMonth: 0,
      year: 0,
      todaysYear: 0,
      holidays: [],
      eventSelected: null,
      editing: false,
      allColors: colors,
      projectIdToColor: [], // try to use a unique color using project id
      shortcutAdd: false,
      shortcutEscp: false,
      shortcutStats: false,
      lockDate: "",
      role: "",
      login: "",
      userId: 0
    };
  },
  created: function() {
    axios
      .get(this.$store.state.apiUrl + "config/getLock", {
        params: {
          login: localStorage.login,
          password: localStorage.pass
        }
      })
      .then(response => (this.lockDate = response.data.paramValue))
      .catch(e => {
        this.printError(e);
      });
  },
  mounted: function() {
    var tmpDate = new Date();
    this.year = tmpDate.getFullYear();
    this.todaysYear = this.year;
    this.curMonth = tmpDate.getMonth() + 1;
    this.today = tmpDate.getDate();
    this.todaysMonth = this.curMonth;
    this.login = localStorage.login;
    this.role = localStorage.role;
    this.userId = Number(localStorage.id);
  },
  watch: {
    lockDate: function() {
      this.setLock();
    },
    curMonth: function() {
      this.setLock();
      this.setDaysInMonth(this.year, this.curMonth - 1); // Get the number of day in this month
      this.calculShift(this.year, this.curMonth);
      this.setWeeksNumber(this.year, this.curMonth);

      axios
        .get(
          this.$store.state.apiUrl +
            "holidays/monthly/" +
            this.curMonth +
            "/" +
            this.year,
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(
          response => (this.resetHolidays(), this.setHolidays(response.data))
        )
        .catch(e => {
          this.printError(e);
        });
      this.getLogs();
    },
    userId: function() {
      this.getLogs();
    }
  },
  methods: {
    resetData: function() {
      this.nbDays = 0;
      this.daySelected = 0;
      this.shiftDay = 0;
      this.weeks = [];
      this.eventSelected = null;
      this.events = [];
      this.holidays = [];
    },
    resetEvents: function() {
      this.events = [];
    },
    resetHolidays: function() {
      this.holidays = [];
    },
    getLogs: function() {
      /* Defined the start of the month and start of the next one */
      var startDate = this.year + "-" + this.curMonth + "-01";
      var nextMonth = this.curMonth + 1; // next month is +1, Date is January based 1 => +1
      var yearNextMonth = this.year;

      if (nextMonth > 12) {
        // handle december
        nextMonth = 1;
        yearNextMonth++;
      }

      var tmpEndDate = new Date(yearNextMonth + "-" + (nextMonth > 10 ? nextMonth : "0" + nextMonth) );

      var endDate =
        tmpEndDate.getFullYear() + "-" + ((tmpEndDate.getMonth() + 1) > 10 ? (tmpEndDate.getMonth() + 1) : "0" + (tmpEndDate.getMonth() + 1)) + "-00"; // getMonth is january 0 based

      axios
        .get(
          this.$store.state.apiUrl +
            "time/leave/" +
            startDate +
            "/" +
            endDate,
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(response => (this.resetEvents(), this.setEvents(response.data)))
        .catch(e => {
          this.printError(e);
        });
    },
    previousMonth: function() {
      this.resetData();
      if (this.curMonth <= 1) {
        this.curMonth = 12;
        this.year--;
      } else {
        this.curMonth--;
      }
    },
    nextMonth: function() {
      this.resetData();
      if (this.curMonth >= 12) {
        this.curMonth = 1;
        this.year++;
      } else {
        this.curMonth++;
      }
    },
    lock: function() {
      var lockDate = this.year + "-" + this.curMonth;

      if (this.$store.state.isLock) {
        lockDate = this.year + "-" + (this.curMonth - 1);
      }

      axios
        .put(
          this.$store.state.apiUrl + "config/updateLock",
          {
            lockedDate: lockDate
          },
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(response => (this.lockDate = response.data.paramValue))
        .catch(e => {
          this.printError(e);
        });
    },
    setLock: function() {
      this.$store.commit('setIsLock', false);
    },
    setDaysInMonth: function(year, month) {
      // January is 0
      this.nbDays = new Date(year, month + 1, 0).getDate();
    },
    calculShift: function(year, month) {
      this.shiftDay = new Date(year + "-" + month + "-01").getDay() - 1; // minus 1 because Dimanche is 0
    },
    setWeeksNumber: function(year, month) {
      this.weeks[0] = this.getWeek(new Date(year + "-" + month + "-01"));

      for (var i = 1; i < 5; ++i) {
        this.weeks[i] = this.weeks[0] + i;
      }
    },
    getWeek: function(d) {
      d = new Date(+d); // Copy date so don't modify original.
      d.setHours(0, 0, 0, 0); // Reset hours.
      d.setDate(d.getDate() + 4 - (d.getDay() || 7)); // Set to nearest Thursday: current date + 4 - current day number and make Sunday's day number 7
      var yearStart = new Date(d.getFullYear(), 0, 1); // Get first day of year
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7); // Calculate full weeks to nearest Thursday
      return weekNo; // Return week number
    },
    setEvents: function(data) {
      if (data) {
        data.forEach(value => {
          var tmpDate = value.date.split("-");
          var dateYear = Number(tmpDate[0]);
          var dateMonth = Number(tmpDate[1]);
          var dateDay = Number(tmpDate[2]); // date's format is Y-M-D
          if (this.year == dateYear && this.curMonth == dateMonth) {
            var tmp;

            if (this.projectIdToColor.indexOf(value.user_id) < 0) {
              this.projectIdToColor.push(value.user_id);
            }

            if (this.events[dateDay] && this.events[dateDay].length > 0) {
              // handle multiple events in a day
              tmp = this.events[dateDay];
              tmp.push(value);
            } else {
              tmp = [value];
            }

            this.$set(this.events, dateDay, tmp);
          }
        });
      }
    },
    setHolidays: function(data) {
      if (data) {
        data.forEach(value => {
          var day = value.date.split("/")[0];
          this.holidays[Number(day)] = true;
        });
      }
    },
    printError: function(e) {
      console.log(e);
      this.$toasted
        .show("Erreur de connexion, veuillez essayer ultérieurement", {
          position: "bottom-center",
          theme: "outline"
        })
        .goAway(2000);
    }
  }
};
</script>

<style scoped>
.events {
  text-align: left;
}

th {
  border-top: 0px;
}

td {
  vertical-align: middle;
}

.smallFont {
  font-size: 12px;
}

.table-sm td {
  padding-top: 0;
  padding-bottom: 0;
}

.details,
.copy {
  width: 1em;
}

.week,
.date,
.number,
.info {
  width: 0.5em;
  border-top: 0px;
}

.b-icon.bi {
  font-size: 1.6em;
}

.add,
.total {
  width: 1em;
}

.total {
  padding: 0px;
}

td.add:hover,
td.details:hover,
td.copy:hover {
  background-color: #e5e5e5;
  cursor: pointer;
}

.table thead th {
  padding: 0;
}

.today {
  border-top: 0px;
  border-bottom: 0px;
  font-weight: normal;
  font-size: 11px;
  width: 2.5em;
  margin: 0;
}

#rightDay {
  background-color: #fff2c6;
  margin-top: 3px;
}

#rightDay:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 11px solid transparent;
  margin: -6px 0 0 0;
  border-left: 20px solid #fec053;
}

tr:first-child {
  background-color: transparent;
}

table {
  font-size: 0.91em;
}

tr:hover {
  background-color: #fce5dc;
}

#nextMonth:hover,
#previousMonth:hover,
td.quickAdd:hover {
  cursor: pointer;
}

.navigation {
  position: absolute;
  top: 25px;
  left: 50%;
  font-size: 24px;
  font-weight: bold;
  width: 440px;
  margin-left: -140px;
  height: 30px;
  text-align: left;
}

.navContent {
  width: 280px;
  text-align: center;
}

.navLogo {
  display: block;
  height: 100%;
}

#loginSelect {
  width: 120px;
  font-size: 16px;
  position: relative;
  background: none;
  overflow: hidden;
  border: 1px solid;
  border-radius: 0.3em;
}

#displayMonth {
  display: inline-block;
  width: 235px;
  height: 100%;
}

#lockBtn {
  margin-left: 10px;
  padding: 0;
  height: 100%;
  background: none;
  border: none;
}

#previousMonth,
#nextMonth {
  font-size: 22px;
}

#previousMonth {
  transform: rotate(-90deg);
}

#nextMonth {
  transform: rotate(90deg);
}

#statsBtn {
  padding: 0;
  height: 100%;
  background: none;
  border: none;
}

@media screen and (max-width: 800px){
  .navigation {
    top: 50px;
    left: 40%;
    max-width: 300px;
    font-size: 17px;
  }
  #displayMonth{
    width: 135px;
  }
}

@media screen and (max-width: 729px){
  .navigation {
    top: 90px;
    left: 55%;
  }
}

@media screen and (max-width: 480px){
  .navigation {
    top: 120px;
    left: 45%;
  }
}

@media screen and (max-width: 360px){
  .navigation {
    top: 140px;
    left: 60%;
  }
}

</style>
